// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const pt: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'Como jogar',
  'howto.pieces.heading': 'As peças',
  'howto.pieces.source': 'Fonte',
  'howto.pieces.mirror': 'Espelho',
  'howto.pieces.switch': 'Interruptor',
  'howto.pieces.exit': 'Saída',
  'howto.pieces.wall': 'Parede',
  'howto.controls.heading': 'Os controlos',
  'howto.controls.clickSlot.line1': 'Clica na casa',
  'howto.controls.clickSlot.line2': 'coloca o espelho',
  'howto.controls.dragMirror.line1': 'Arrasta o espelho',
  'howto.controls.dragMirror.line2': 'roda',
  'howto.controls.rightClick.line1': 'Clique direito',
  'howto.controls.rightClick.line2': 'remove o espelho',
  'howto.controls.hint': 'Roda do rato: rotação fina de 1°.   Toca no espelho: rotação de 15°.',
  'howto.objective.line1': 'Acende cada interruptor — o trinco da saída abre-se.',
  'howto.objective.line2':
    'Depois clica na saída. Resolve com o menor número de espelhos possível.',

  'howtoColor.title': 'Cor e prismas',
  'howtoColor.pieces.heading': 'Novas peças',
  'howtoColor.pieces.prism': 'Prisma',
  'howtoColor.pieces.redSwitch': 'Interruptor vermelho',
  'howtoColor.pieces.yellowSwitch': 'Interruptor amarelo',
  'howtoColor.pieces.whiteSwitch': 'Interruptor branco',
  'howtoColor.how.heading': 'Como funcionam',
  'howtoColor.how.line1': 'Um raio branco transporta luz vermelha, verde e azul ao mesmo tempo.',
  'howtoColor.how.line2':
    'Um prisma divide a luz branca em três raios coloridos pelos seus três lados.',
  'howtoColor.how.line3': 'Clica num prisma colocado para rodar a sua face de entrada.',
  'howtoColor.switches.line1': 'Os interruptores mostram pontos coloridos — é a cor que pedem.',
  'howtoColor.switches.line2':
    'Um interruptor amarelo (pontos vermelho + verde) precisa das duas cores em simultâneo.',
  'howtoColor.switches.line3':
    'Um interruptor branco (as três) precisa de vermelho, verde E azul em simultâneo.',

  'options.hints.label': 'Mostrar ângulos de ajuda nos puzzles',
  'options.hints.help': 'Mostra o ângulo entre o raio incidente e o refletido em cada ressalto.',

  'level.01-intro.title': 'Olá, luz',
  'level.02-two-mirrors.title': 'Duas curvas',
  'level.03-corner.title': 'Parede no caminho',
  'level.04-two-targets.title': 'Dois alvos',
  'level.05-tight.title': 'Apertado',
  'level.06-hello-color.title': 'Olá, cor',
  'level.07-pick-a-side.title': 'Escolhe um lado',
  'level.08-yellow.title': 'Amarelo',
  'level.09-magenta.title': 'Magenta',
  'level.10-spectrum.title': 'Espetro',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'reto',
  'puzzle.hint.angleType.acute': 'agudo',
  'puzzle.hint.angleType.obtuse': 'obtuso',
  'puzzle.hint.label': '{angle}°\n{type}',
};
